const S = {
  page: { background: "#f5f6fa", minHeight: "100vh" },

  card: {
    background: "#fff",
    borderRadius: "14px",
    boxShadow: "0 1px 6px rgba(0,0,0,0.07)",
    border: "1px solid #e8eaf0",
    overflow: "hidden",
    marginBottom: "16px",
  },

  cardHeader: {
    padding: "16px 20px",
    borderBottom: "1px solid #f0f2f7",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },

  cardHeaderLeft: { display: "flex", alignItems: "center", gap: "10px" },

  cardIconWrap: (color = "green") => ({
    width: "34px", height: "34px", borderRadius: "9px", flexShrink: 0,
    display: "flex", alignItems: "center", justifyContent: "center",
    background: color === "green" ? "#e8f5ee" : color === "blue" ? "#e8f0fe" : color === "amber" ? "#fff8e1" : "#f0f2f7",
  }),

  cardTitle: { fontSize: "14.5px", fontWeight: "700", color: "#241E14", margin: 0 },
  cardSubtitle: { fontSize: "11.5px", color: "#8A7E6A", margin: "2px 0 0" },
  cardBody: { padding: "18px 20px" },
  divider: { height: "1px", background: "#f0f2f7", margin: "16px 0" },

  toggleWrap: {
    display: "flex", alignItems: "center", justifyContent: "space-between",
    padding: "14px 20px", cursor: "pointer", userSelect: "none",
  },

  toggleLeft: { display: "flex", alignItems: "center", gap: "10px" },
  toggleTitle: { fontSize: "14px", fontWeight: "600", color: "#241E14" },
  toggleDesc: { fontSize: "12px", color: "#8A7E6A", marginTop: "1px" },

  toggleTrack: (on) => ({
    width: "42px", height: "24px", borderRadius: "12px",
    background: on ? "#1E5B3A" : "#d8dde8",
    position: "relative", transition: "background 0.2s",
    flexShrink: 0, cursor: "pointer", border: "none", outline: "none", padding: 0,
  }),

  // FIX: smoother easing + pointerEvents none so thumb doesn't intercept clicks
  toggleThumb: (on) => ({
    position: "absolute", top: "3px", left: on ? "21px" : "3px",
    width: "18px", height: "18px", borderRadius: "50%",
    background: "#fff",
    transition: "left 0.18s cubic-bezier(0.4, 0, 0.2, 1)",
    boxShadow: "0 1px 3px rgba(0,0,0,0.2)",
    pointerEvents: "none",
  }),

  collapsibleBody: { padding: "4px 20px 18px", borderTop: "1px solid #f0f2f7" },

  fieldWrap: { marginBottom: "14px" },
  label: { display: "block", fontSize: "13px", fontWeight: "600", color: "#4a5168", marginBottom: "5px" },
  required: { color: "#d32f2f", marginLeft: "2px" },
  hint: { fontSize: "11.5px", color: "#8A7E6A", marginTop: "4px" },

  input: {
    width: "100%", padding: "10px 12px", border: "1.5px solid #e3e7f0",
    borderRadius: "9px", fontSize: "14px", color: "#241E14",
    background: "#fff", outline: "none", boxSizing: "border-box",
  },

  inputDisabled: { background: "#f5f6fa", color: "#8A7E6A", cursor: "not-allowed" },

  select: {
    width: "100%", padding: "10px 12px", border: "1.5px solid #e3e7f0",
    borderRadius: "9px", fontSize: "14px", color: "#241E14",
    background: "#fff", outline: "none", cursor: "pointer", boxSizing: "border-box",
  },

  textarea: {
    width: "100%", padding: "10px 12px", border: "1.5px solid #e3e7f0",
    borderRadius: "9px", fontSize: "14px", color: "#241E14",
    background: "#fff", outline: "none", resize: "vertical",
    boxSizing: "border-box", lineHeight: "1.6",
  },

  row2: { display: "grid", gridTemplateColumns: "1fr 1fr", gap: "12px" },
  row3: { display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: "10px" },
  row4: { display: "grid", gridTemplateColumns: "1fr 1fr 1fr 1fr", gap: "10px" },

  btnPrimary: {
    display: "inline-flex", alignItems: "center", gap: "6px",
    padding: "10px 22px", background: "#1E5B3A", color: "#fff",
    border: "none", borderRadius: "9px", fontSize: "14px", fontWeight: "600", cursor: "pointer",
  },

  btnOutline: {
    display: "inline-flex", alignItems: "center", gap: "6px",
    padding: "8px 14px", background: "transparent", color: "#1E5B3A",
    border: "1.5px solid #1E5B3A", borderRadius: "9px", fontSize: "13px", fontWeight: "600", cursor: "pointer",
  },

  btnGhost: {
    display: "inline-flex", alignItems: "center", gap: "5px",
    padding: "7px 14px", background: "transparent", color: "#5a6478",
    border: "1.5px solid #e3e7f0", borderRadius: "8px", fontSize: "13px", cursor: "pointer",
  },

  btnDanger: {
    padding: "4px 10px", background: "#fff0f0", color: "#d32f2f",
    border: "none", borderRadius: "7px", cursor: "pointer", fontSize: "12px", fontWeight: "500",
  },

  badge: (color = "green") => ({
    display: "inline-flex", alignItems: "center", gap: "4px",
    padding: "4px 10px", borderRadius: "20px", fontSize: "12px", fontWeight: "600", margin: "2px",
    background: color === "green" ? "#e8f5ee" : color === "blue" ? "#e8f0fe" : "#fff3e0",
    color: color === "green" ? "#1E5B3A" : color === "blue" ? "#1a56db" : "#c05500",
  }),

  chip: {
    display: "inline-flex", alignItems: "center", gap: "4px",
    padding: "3px 9px", borderRadius: "16px", fontSize: "12px", fontWeight: "500",
    background: "#eef6f1", color: "#1E5B3A", border: "1px solid #c5e3d1", margin: "2px",
  },

  errorText: { fontSize: "12px", color: "#d32f2f", marginTop: "4px", display: "flex", alignItems: "center", gap: "3px" },

  infoBox: {
    background: "#f0faf4", border: "1px solid #b5dfc8", borderRadius: "9px",
    padding: "10px 13px", fontSize: "12.5px", color: "#145a32",
    display: "flex", alignItems: "flex-start", gap: "7px", marginBottom: "14px",
  },

  uploadArea: {
    border: "2px dashed #c8d3e8", borderRadius: "12px", padding: "24px 16px",
    textAlign: "center", cursor: "pointer", background: "#f9fafc", display: "block", marginBottom: "10px",
  },

  thumb: {
    position: "relative", width: "88px", height: "88px", borderRadius: "9px",
    overflow: "hidden", display: "inline-block", margin: "4px",
    border: "2px solid #eef0f7", verticalAlign: "top",
  },

  thumbRemove: {
    position: "absolute", top: "3px", right: "3px",
    background: "rgba(0,0,0,0.55)", border: "none", borderRadius: "50%",
    width: "20px", height: "20px", display: "flex", alignItems: "center",
    justifyContent: "center", cursor: "pointer", color: "#fff", padding: 0,
  },

  thumbMain: {
    position: "absolute", bottom: 0, left: 0, right: 0,
    background: "rgba(7,101,52,0.85)", color: "#fff",
    fontSize: "9px", fontWeight: "700", textAlign: "center", padding: "2px",
  },

  shippingOption: (active) => ({
    flex: 1, padding: "12px", borderRadius: "10px", cursor: "pointer", textAlign: "center",
    border: active ? "2px solid #1E5B3A" : "1.5px solid #e3e7f0",
    background: active ? "#f0faf4" : "#fff", transition: "all 0.15s",
  }),

  slugWrap: {
    display: "flex", alignItems: "center", border: "1.5px solid #e3e7f0",
    borderRadius: "9px", overflow: "hidden", background: "#fff",
  },

  slugPrefix: {
    padding: "10px 10px", background: "#f5f6fa", color: "#8A7E6A",
    fontSize: "11.5px", borderRight: "1px solid #e3e7f0", whiteSpace: "nowrap",
  },

  overlay: {
    position: "fixed", inset: 0, background: "rgba(0,0,0,0.4)",
    display: "flex", alignItems: "center", justifyContent: "center", zIndex: 9999,
  },

  modal: {
    background: "#fff", borderRadius: "14px", width: "400px", maxWidth: "94vw",
    boxShadow: "0 16px 48px rgba(0,0,0,0.18)", overflow: "hidden",
  },

  modalHead: {
    padding: "15px 18px", borderBottom: "1px solid #f0f2f7",
    display: "flex", justifyContent: "space-between", alignItems: "center",
  },

  modalBody: { padding: "16px 18px" },
  modalFoot: { padding: "12px 18px", borderTop: "1px solid #f0f2f7", display: "flex", justifyContent: "flex-end", gap: "10px" },

  checkRow: {
    display: "flex", alignItems: "flex-start", gap: "10px",
    padding: "12px 14px", background: "#f9fafc", borderRadius: "9px",
    border: "1px solid #eef0f5",
  },

  // FIX: plain object — NOT a function. opacity/cursor handled inline in JSX
  submitBtn: {
    display: "inline-flex", alignItems: "center", gap: "8px",
    padding: "12px 40px", background: "#1E5B3A", color: "#fff",
    border: "none", borderRadius: "10px", fontSize: "15px",
    fontWeight: "700", transition: "background 0.15s",
  },

  serpCard: {
    background: "#f9fafc", borderRadius: "10px", border: "1px solid #eef0f5",
    padding: "14px 18px", marginTop: "14px",
  },

  formFooter: {
    padding: "16px 20px", background: "#f9fafc", borderTop: "1px solid #eef0f5",
    display: "flex", justifyContent: "flex-end", gap: "12px",
    borderRadius: "0 0 14px 14px",
  },

  backBtn: {
    background: "none", border: "none", cursor: "pointer",
    display: "flex", alignItems: "center", gap: "6px",
    color: "#5a6478", fontWeight: "600", fontSize: "14px", padding: 0, marginRight: "12px",
  },
};

export default S;